import { BodyText, TitleText, theme } from '@policygenius/mortar';
import styled, { css } from 'styled-components';
import { victorSerif } from '../typography';

export const CalculatorContainer = styled.div`
  margin-top: 24px;
  margin-bottom: 16px;
  padding: 0 16px;

  & > div {
    & > div {
      flex-direction: column;
    }
  }

  @media (min-width: ${theme.breakpoints.medium}px) {
    margin-top: 48px;
    margin-bottom: 16px;

    & > div {
      & > div {
        flex-direction: row;
      }
    }
  }
`;

export const Background = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 0;
  margin-bottom: 0;
`;

export const EstimatePrompt = styled(BodyText)`
  ${victorSerif()};
  color: #131212;
`;

export const CalculatorTitle = styled(TitleText)`
  ${victorSerif()};
  padding: 0 16px;
  font-size: 34px;
  line-height: 1.1;
  color: #131212;

  @media (min-width: ${theme.breakpoints.medium}px) {
    font-size: 64px;
    line-height: 1.1;
  }
`;

export const CalculatorTitleHighlight = styled.span`
  position: relative;
  display: inline;
  white-space: nowrap;
`;

export const CalculatorTitleUnderlineWrap = styled.span`
  position: absolute;
  left: 0;
  bottom: -10px;
  width: 100%;
  line-height: 0;
  pointer-events: none;
`;

const calculatorTitleUnderlineDraw = css`
  @keyframes calculatorTitleUnderlineDraw {
    from {
      stroke-dashoffset: 1;
    }
    to {
      stroke-dashoffset: 0;
    }
  }
`;

export const CalculatorTitleUnderlineSvg = styled.svg`
  display: block;
  width: 100%;
  height: auto;

  path {
    stroke-dasharray: 1;
    stroke-dashoffset: 1;
    animation: calculatorTitleUnderlineDraw 0.9s cubic-bezier(0.4, 0, 0.2, 1) 0.35s forwards;
  }

  ${calculatorTitleUnderlineDraw}

  @media (prefers-reduced-motion: reduce) {
    path {
      stroke-dashoffset: 0;
      animation: none;
    }
  }
`;
